/**
 * Runtime leads / intake module gate (business_info.leads_enabled).
 */
export function isLeadsFeatureActive (businessInfo) {
  return !!businessInfo?.leads_enabled
}
